<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <SaralaTable :model="model" ref="table" :exportable="true">
                    <template #[`reseller.trade_name`]="{ item }">{{
                        item.reseller.trade_name
                    }}</template>

                    <template #paid_at="{ item }">{{
                        item.formattedPaidAt
                    }}</template>

                    <template #has_negotiation="{item}">
                        <v-icon v-if="item.has_negotiation" color="green">
                            mdi-check
                        </v-icon>
                        <v-icon v-else color="red">
                            mdi-close
                        </v-icon>
                    </template>

                    <!-- <template #action="{ item }">
                        <v-tooltip bottom v-if="item.url">
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    :href="item.url"
                                    target="_blank"
                                >
                                    <v-icon v-on="on">mdi-open-in-new</v-icon>
                                </v-btn>
                            </template>
                            <span>{{
                                $t('resources.bill.actions.accessPaymentPage')
                            }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="showItem(item)"
                                >
                                    <v-icon color="blue-grey" v-on="on"
                                        >mdi-eye</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.show') }}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    icon
                                    tile
                                    v-on="on"
                                    @click="editItem(item)"
                                >
                                    <v-icon color="blue-grey" v-on="on"
                                        >mdi-pencil</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>{{ $t('form.actions.edit') }}</span>
                        </v-tooltip>
                    </template> -->
                    <template #actionHandler>
                        <BillActions
                            ref="actionHandler"
                            @modelChanged="$refs.table.getItems()"
                        />
                    </template>
                </SaralaTable>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Bill from '@/models/Bill'
import BillActions from '@/components/actions/bill/BillActions'
import SaralaTable from '@/shared/components/SaralaTable'

export default {
    components: {
        SaralaTable,
        BillActions,
    },

    computed: {
        model() {
            return new Bill()
        },
    },

    methods: {
        showItem(item) {
            this.$router.push({
                name: 'bills.show',
                params: { id: item.id },
            })
        },

        editItem(item) {
            this.$router.push({
                name: 'bills/edit',
                params: { id: item.id },
            })
        },

        reloadItems() {
            this.$refs.table.getItems()
        },
    },
}
</script>
